import { JSX } from 'react';
import { C01AccordionProps } from './C01Accordion.types';
import { AccordionWrapper } from '@ahc-digital/component-library';
import { CreateAccordionWrapperModel } from './C01Accordion.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C01AccordionProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <AccordionWrapper
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateAccordionWrapperModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C01AccordionProps>(Default);
